import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class TasApplicationsShowController extends Controller {
  @tracked applicationSubmitted: boolean = false;

  queryParams = ['applicationSubmitted'];
}
